/* eslint-disable import/no-named-as-default */
import { configureStore } from "@reduxjs/toolkit";
import chart from "./chart-reducer";
import member from "./list-member";
import image from "./image-reducer";

export default configureStore({
  reducer: { chart, member, image },
});